<template lang="pug">
  .card.mb-0
    .card-body
      .row
        .col-12.mb-1
          h2.section-title.mt-0 {{ id }}
        .col-6(style="max-height: 70vh; overflow: hidden;")
          .clusterize-scroll.table-responsive
            table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle#tblList
              thead.thead-light
                tr
                  th.text-center(width="5%")
                    span #
                  th(width="45%")
                    span(:title="$t('ui.account_id')") {{ $t('ui.account_id') }}
                  th(width="50%")
                    span(:title="$t('ui.contact_phone')") {{ $t('ui.contact_phone') }}
              tbody.clusterize-content
                tr(v-if="list.length == 0")
                  td(colspan="3").text-center
                    span {{ $t('message.no_data_available') }}
                tr(v-for="(item, index) in list")
                  td.text-center
                    span(:title="index + 1") {{ index + 1 }}
                  td
                    span(:title="item.account_id") {{ item.account_id }}
                  td
                    span(:title="item.contact_phone") {{ item.contact_phone }}
  
  </template>
  
  <script>
  import config from "@/config";
  import errorTags from "@/errorTags";
  import SubmitButton from "@/library/SubmitButton.vue";
  import DebounceInput from "@/library/DebounceInput";
  
  export default {
    components: {
      SubmitButton,
      DebounceInput
    },
    props: {
      id: {
        type: String,
        default: ''
      },
      date: {
        type: Object,
        default: ""
      },
    },
    data: () => ({
      loading: false,
      list: [],
      feedback: {
        success: false,
        status: errorTags.request.failed
      }
    }),
    computed: {
      getPageSize() {
        return this.$store.getters.pageSize;
      },
    },
    mounted: function() {  },
    methods: {
      getList: function(isSearch) {
        let url = config.uniqueWithdrawalUrl();
  
        if (isSearch) this.currentPage = 1;
  
        var json = {
          action_by: this.$store.getters.loginId,
          auth_token: this.$store.getters.sessionToken,
          operator_id: this.id,
          start_date: this.date.startDate,
          end_date: this.date.endDate
        };
  
        this.loading = true;
        this.$http.post(url, json).then(
          function(response) {
            this.loading = false;
            // Success
            try {
              if (response) {
                this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;
  
                this.feedback.status = response.data.statusdesc;
                if (this.feedback.success == true) {
                  this.list = response.data.dt;
                } else {
                  if (this.feedback.status != 'permission_denied') {
                    if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
                  }
                  else {
                    this.$helpers.showToast(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
                  }
                }
              }
            } catch (error) {
              this.feedback.success = false;
              this.feedback.status = errorTags.request.failed;
              this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
            }
          },
          function(response) {
            this.loading = false;
            // Error
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        );
      },
      handleFailed: function(tag, status) {
        this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
      }
    }
  };
  </script>